<script lang="ts">
export const elAvatarSizes = ['xxs', 'xs', 'sm', 'md', 'lg', 'xl'] as const;
export type ElAvatarSize = (typeof elAvatarSizes)[number];
</script>

<script lang="ts" setup>
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    picture?: string;
    size: ElAvatarSize;
    label?: string;
  }>(),
  {
    picture: undefined,
    size: 'md',
    label: undefined,
  },
);

const initials = computed(() => {
  if (!props.label) return '';
  const trimmedFullName = props.label.trim();
  let initialNames = '';
  initialNames += trimmedFullName.trim().charAt(0);
  const lastSurnameFirstChar = trimmedFullName.lastIndexOf(' ');
  initialNames += trimmedFullName.charAt(lastSurnameFirstChar === -1 ? lastSurnameFirstChar + 2 : lastSurnameFirstChar + 1);
  return initialNames.toUpperCase();
});
</script>

<template>
  <div v-if="picture">
    <img
      alt="avatar"
      class="rounded-full object-cover"
      :class="{
        'w-36 h-36 text-5xl': size === 'xl',
        'w-20 h-20 text-3xl': size === 'lg',
        'w-14 h-14 text-2xl': size === 'md',
        'w-10 h-10 text-base': size === 'sm',
        'w-8 h-8 text-sm': size === 'xs',
        'w-5 h-5 text-xs': size === 'xxs',
      }"
      :src="picture"
    />
  </div>
  <div
    v-else-if="props.label"
    class="rounded-full bg-brandBlue-100 text-neutral-darker flex justify-center items-center"
    :class="{
      'w-36 h-36 text-5xl': size === 'xl',
      'w-20 h-20 text-3xl': size === 'lg',
      'w-14 h-14 text-2xl': size === 'md',
      'w-10 h-10 text-base': size === 'sm',
      'w-8 h-8 text-sm': size === 'xs',
      'w-5 h-5 text-xs': size === 'xxs',
    }"
  >
    {{ initials }}
  </div>
</template>
